import React from 'react';
import { Box, Card, Grid, Stack, Typography } from '@mui/material';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { WeeklyMetric } from '../mockStats';

interface WeeklySnapshotProps {
  metrics: WeeklyMetric[];
}

const WeeklySnapshot: React.FC<WeeklySnapshotProps> = ({ metrics }) => (
  <Card>
    <Stack spacing={2}>
      <Box>
        <Typography variant={'h3'}>{'Тиждень коротко'}</Typography>
        <Typography color={'text.secondary'}>
          {'Останні 7 днів проти попередніх 7.'}
        </Typography>
      </Box>

      <Grid container spacing={2}>
        {metrics.map((m) => (
          <Grid key={m.key} size={{ xs: 6, md: 3 }}>
            <MetricTile metric={m} />
          </Grid>
        ))}
      </Grid>
    </Stack>
  </Card>
);

const MetricTile: React.FC<{ metric: WeeklyMetric }> = ({ metric }) => {
  const positive = metric.deltaPct >= 0;
  return (
    <Box
      sx={(theme) => ({
        borderRadius: 2,
        border: `1px solid ${
          theme.palette.mode === 'dark' ? '#303A48' : theme.palette.primary.tableBorder
        }`,
        p: 2,
        height: '100%',
      })}
    >
      <Typography variant={'body2'} color={'text.secondary'}>
        {metric.label}
      </Typography>
      <Stack direction={'row'} alignItems={'baseline'} spacing={0.75} sx={{ mt: 0.5 }}>
        <Typography variant={'h4'} sx={{ color: 'primary.main', fontWeight: 800 }}>
          {metric.value}
        </Typography>
        {metric.unit && (
          <Typography variant={'body2'} color={'text.secondary'}>
            {metric.unit}
          </Typography>
        )}
      </Stack>
      <Stack direction={'row'} alignItems={'center'} sx={{ mt: 0.5 }}>
        {positive ? (
          <ArrowDropUpIcon sx={{ color: 'primary.aqua' }} />
        ) : (
          <ArrowDropDownIcon sx={{ color: 'secondary.main' }} />
        )}
        <Typography
          variant={'body2'}
          sx={{
            color: positive ? 'primary.aqua' : 'secondary.main',
            fontWeight: 700,
          }}
        >
          {`${positive ? '+' : ''}${metric.deltaPct}%`}
        </Typography>
        <Typography variant={'body2'} color={'text.secondary'} sx={{ ml: 0.5 }}>
          {'vs мин. тижня'}
        </Typography>
      </Stack>
    </Box>
  );
};

export default WeeklySnapshot;
